(function () {
    'use strict';

    angular
        .module('app.influencerGroup', [])
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.influencer', {
                    requireLogin: true,
                    url: 'influencer',
                    templateUrl: 'app/influencerGroup/influencerGroup.html?app_v=deployDate',
                    data: {
                        authorizedRoles: ['Administrator', 'User', 'Achoo Analyst'],
                        navMarker: ['influencer']
                    },
                    controller: 'influencerGroupCtrl'
                })
        }]);
})();